import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { nav, skillGroups } from '../data/content';
import Section from './Section';

export default function Skills() {
  const { t } = useLanguage();

  return (
    <Section id="skills" title={t(nav.skills)}>
      {/* 같은 비중의 카드 세 장, 높이는 그리드가 맞춘다 */}
      <div className="grid gap-4 sm:gap-5 md:grid-cols-3">
        {skillGroups.map((group) => (
          <div key={group.name} className="flex flex-col rounded-sm border border-stone-200 bg-white p-5 sm:p-6">
            <h3 className="text-base font-bold tracking-tight">{group.name}</h3>
            <p className="mt-1.5 text-pretty text-xs leading-relaxed text-stone-500">{t(group.desc)}</p>

            <dl className="mt-5 space-y-4 border-t border-stone-200 pt-5">
              {group.rows.map((row) => (
                <div key={row.label.en}>
                  <dt className="text-[11px] uppercase tracking-[0.18em] text-stone-500">{t(row.label)}</dt>
                  <dd className="mt-2 flex flex-wrap gap-1.5">
                    {row.items.map((item) => (
                      <span
                        key={item}
                        className="whitespace-nowrap rounded-full border border-stone-300 bg-stone-50 px-2.5 py-1 text-xs leading-none text-stone-700"
                      >
                        {item}
                      </span>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </Section>
  );
}
